import { useSetRecoilState } from 'recoil';
import { getIntegrations } from '../../services/integrationService';
import {
  integrationsPageState,
  integrationsState,
  loadingIntegrationsState,
  searchIntegrationState,
} from '../../storage/integrations';
import { Integration } from '../../types/integrations';
import { PaginatedProvider } from './PaginatedProvider';

function IntegrationsProvider() {
  const setPaginatedIntegrations = useSetRecoilState(integrationsState);
  const setLoadingIntegrations = useSetRecoilState(loadingIntegrationsState);

  return (
    <PaginatedProvider<Integration>
      searchState={searchIntegrationState}
      pageState={integrationsPageState}
      getPaginated={getIntegrations}
      setPaginated={setPaginatedIntegrations}
      onSearchChange={() => {}}
      onUpdateFinish={() => {}}
      setLoading={setLoadingIntegrations}
    />
  );
}

export default IntegrationsProvider;
